<template>
  <div class="big">
    <div class="page_title">医生自动标签</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="searchbox wrap">
          <div class="item">
            <span>标签名称</span>
            <el-input placeholder="请输入"
                      v-model="label_name"
                      style="width: 160px;margin-left: 8px"
                      clearable=""
                      @change="search"></el-input>
          </div>
          <div class="item">
            <span>更新方式</span>
            <el-select style="width: 160px;margin-left: 8px"
                       @change="search"
                       v-model="update_type"
                       placeholder="请选择">
              <el-option label="全部"
                         :value="0"></el-option>
              <el-option label="手动"
                         :value="1"></el-option>
              <el-option label="例行"
                         :value="2"></el-option>
            </el-select>
          </div>
          <div class="item">
            <span>标签状态</span>
            <el-select style="width: 160px;margin-left: 8px"
                       v-model="label_status"
                       @change="search"
                       placeholder="请选择">
              <el-option label="全部"
                         :value="''"></el-option>
              <el-option label="正常"
                         :value="1"></el-option>
              <el-option label="暂停"
                         :value="0"></el-option>
            </el-select>
          </div>
          <div class="item">
            <span>创建方式</span>
            <el-select style="width: 160px;margin-left: 8px"
                       v-model="create_type"
                       @change="search"
                       placeholder="请选择">
              <el-option label="全部"
                         :value="0"></el-option>
              <el-option label="自定义标签"
                         :value="1"></el-option>
              <el-option label="sql计算结果"
                         :value="2"></el-option>
              <el-option label="导入创建"
                         :value="3"></el-option>
            </el-select>
          </div>
          <div class="item">
            <span>标签分类</span>
            <el-select style="width: 160px;margin-left: 8px"
                       v-model="label_category_id"
                       @change="search"
                       placeholder="请选择">
              <el-option label="全部"
                         :value="0"></el-option>
              <el-option :label="item.label_category_name"
                         :value="item.label_category_id"
                         v-for="(item, index) in label_List"
                         :key="index">
              </el-option>
            </el-select>
            <el-button type="info"
                       @click="search"
                       style="
                background-color: #eceff2;
                color: #747981;
                margin-left: 10px;
              ">查询</el-button>
            <el-button type="primary"
                       @click="addLabel"
                       :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1234')
                      : false
                  ">创建标签</el-button>
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6;">
          <el-table ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%; min-width: 1000px"
                    :header-cell-style="{ background: '#F5F5F5' }"
                    @sort-change="changeOrder">
            <el-table-column prop="label_name"
                             label="标签名称"
                             width="260">
            </el-table-column>
            <el-table-column label="标签分类"
                             prop="label_category_name">

            </el-table-column>
            <el-table-column label="更新方式">
              <template slot-scope="scope">
                <span v-if="scope.row.update_type==1">手动</span>
                <span v-if="scope.row.update_type==2">例行</span>
              </template>
            </el-table-column>
            <el-table-column prop="doctor_count"
                             label="标签覆盖人数"></el-table-column>
            <el-table-column prop="doctor_update_time"
                             label="更新时间"></el-table-column>
            <el-table-column label="标签状态">
              <template slot-scope="scope">
                <div v-if="scope.row.label_status==1">正常</div>
                <div v-if="scope.row.label_status==0">暂停</div>
              </template>
            </el-table-column>
            <el-table-column label="创建方式">
              <template slot-scope="scope">
                <div v-if="scope.row.create_type==1">自定义标签</div>
                <div v-if="scope.row.create_type==2">sql计算结果</div>
                <div v-if="scope.row.create_type==3">导入创建</div>
              </template>
            </el-table-column>
            <el-table-column prop="create_time"
                             label="创建时间"
                             sortable="custom"></el-table-column>
            <el-table-column label="操作"
                             width="260">
              <template slot-scope="scope">
                <el-button type="text"
                           size="medium"
                           :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1239')
                      : false
                  "
                           @click="manualUpdateLabel(scope.row.label_id)"
                           v-if="scope.row.update_type==2&&scope.row.label_status==1">更新</el-button>
                <el-button type="text"
                           size="medium"
                           :disabled="module_id_array[0]? !module_id_array.includes('1223'): false"
                           @click="doctorLabelListStop(scope.row.label_id,0)"
                           v-if="scope.row.update_type==2&&scope.row.label_status==1">暂停</el-button>
                <el-button type="text"
                           size="medium"
                           :disabled="module_id_array[0]? !module_id_array.includes('1223'): false"
                           @click="doctorLabelListStop(scope.row.label_id,1)"
                           v-if="scope.row.update_type==2&&scope.row.label_status==0">恢复</el-button>
                <el-button type="text"
                           size="medium"
                           :disabled="module_id_array[0]? !module_id_array.includes('1239'): false"
                           @click="manualUpdateLabel(scope.row.label_id)"
                           v-if="scope.row.update_type==1">更新</el-button>

                <el-button type="text"
                           size="medium"
                           :disabled="module_id_array[0]? !module_id_array.includes('1234'): false"
                           @click="toEdit(scope.row.label_id,scope.row.create_type)"
                           editlabel>编辑</el-button>
                <el-button type="text"
                           size="medium"
                           :disabled="module_id_array[0]? !module_id_array.includes('1225'): false"
                           @click="toDetail(scope.row.label_id)">详情</el-button>
                <el-button type="text"
                           size="medium"
                           :disabled="module_id_array[0]? !module_id_array.includes('1224'): false"
                           @click="doctorLabelListDel(scope.row.label_id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="text-align: center">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page="currentPage"
                         :page-sizes="[10, 20, 50, 100]"
                         :page-size="10"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="totalNum"
                         style="margin: 30px 0 20px 0"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';

export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      label_name: '',
      update_type: '',
      label_status: '',
      create_type: '',
      label_category_id: 0,
      orderby: 0,
      label_List: []
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        label_name: this.label_name,
        update_type: this.update_type,
        label_status: this.label_status,
        create_type: this.create_type,
        label_category_id: this.label_category_id,
        orderby: this.orderby
      };
      this.axios.post('platform/Doctor/doctorLabelList', data).then((res) => {
        if (res.code == 0) {
          if (!res.data.list.length && this.currentPage > 1) {
            this.currentPage = this.currentPage - 1;
            this.getList();
          }
          this.tableData = res.data.list.map((item) => {
            item.doctor_update_time = item.doctor_update_time
              ? dayjs.unix(item.doctor_update_time).format('YYYY-MM-DD HH:mm')
              : '';
            item.create_time = item.create_time
              ? dayjs.unix(item.create_time).format('YYYY-MM-DD HH:mm')
              : '';
            return item;
          });
          this.totalNum = res.data.total;
        }
      });
    },
    //医生标签分类
    doctorLabelCategory() {
      this.axios.post('platform/Doctor/doctorLabelCategory').then((res) => {
        this.label_List = res.data.list;
      });
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    changeOrder(value) {
      //升序
      if (value.order == 'ascending') {
        this.orderby = 1;
      }
      //降序
      if (value.order == 'descending') {
        this.orderby = 2;
      }
      if (!value.order) {
        this.orderby = 0;
      }
      this.getList();
    },
    //详情
    toDetail(label_id) {
      this.$router.push({
        path: 'labeldetail',
        query: {
          label_id
        }
      });
    },
    toEdit(label_id, create_type) {
      this.$router.push({
        path: 'editlabel',
        query: {
          label_id,
          create_type
        }
      });
    },
    //添加标签
    addLabel() {
      this.$router.push('addlabel');
    },
    //医生标签暂停启用
    doctorLabelListStop(label_id, label_status) {
      let text = '确定暂停更新该标签？';
      if (label_status) {
        text = '确定恢复更新该标签？';
      }
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/Doctor/doctorLabelListStop', {
              label_id,
              label_status
            })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('操作成功!');
                this.getList();
              }
            });
        })
        .catch();
    },
    //删除医生标签
    doctorLabelListDel(label_id) {
      this.$confirm('确定删除该标签？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/Doctor/doctorLabelListDel', { label_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('操作成功!');
                this.getList();
              }
            });
        })
        .catch();
    },
    manualUpdateLabel(label_id) {
      this.$confirm('确定手动更新该标签？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.axios
            .post('platform/Doctor/manualUpdateLabel', { label_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('操作成功!');
                this.getList();
              }
            });
        })
        .catch();
    }
  },
  created() {
    this.getList();
    this.doctorLabelCategory();
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.searchbox {
  display: flex;
  .item {
    margin-right: 20px;
    margin-bottom: 10px;
  }
}
.searh_icon {
  width: 50px;
  height: 38px;
  line-height: 38px;
  background: #ececec;
  position: absolute;
  font-size: 18px;
  right: 1px;
  top: 1px;
  cursor: pointer;
  color: #747e81;
}
.myform {
  width: 500px;
  padding-top: 20px;
}
</style>